import { getColors } from "../../utils";

const getStyles = () => {
  const colors = getColors();

  return {
    title: {
      alignSelf: "stretch",
      textAlign: "center" as const,
      paddingBottom: "8px",
    },
    subtitle: {
      alignSelf: "stretch",
      color: colors.bgDarkGrey,
      textAlign: "center" as const,
    },
    topContainer: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center",
      gap: "20px",
      alignSelf: "stretch",
      marginBottom: "8px",
    },
  };
};

export default getStyles;